"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBusinessIdentifierLabel = void 0;
var DEFAULT_COUNTRY_LABEL_MAP = { US: 'FEIN' };
function getBusinessIdentifierLabel(countryCode, countryLabelMap) {
    var labelMap = countryLabelMap || DEFAULT_COUNTRY_LABEL_MAP;
    return labelMap[countryCode] || labelMap.intl || 'Business identifier';
}
exports.getBusinessIdentifierLabel = getBusinessIdentifierLabel;
//# sourceMappingURL=get-business-identifier-label.js.map